import { useEffect } from 'react'
import { toastEventDispatch } from '@space-lib-events/toast'
import { ToastPosition, ToastType } from '@space-lib-events/toast/enum'
import i18n from 'src/i18n'
import { ConnectionMonitoProps } from './connectionMonitor.types'

const ConnectionMonitor = ({ onConnect, onDisconnect }: ConnectionMonitoProps) => {
  useEffect(() => {
    const handleConnectionError = () => {
      toastEventDispatch({
        type: ToastType.DANGER,
        message: i18n.t('toasts.connection_error'),
        position: ToastPosition.BOTTOM_RIGHT
      })

      onDisconnect?.()
    }

    const handleConnectionSuccess = () => {
      toastEventDispatch({
        type: ToastType.SUCCESS,
        message: i18n.t('toasts.connection_success'),
        position: ToastPosition.BOTTOM_RIGHT
      })

      onConnect?.()
    }

    window.addEventListener('offline', handleConnectionError)
    window.addEventListener('online', handleConnectionSuccess)

    return () => {
      window.removeEventListener('offline', handleConnectionError)
      window.removeEventListener('online', handleConnectionSuccess)
    }
  }, [])

  return null
}

export default ConnectionMonitor
